import React, { useId } from 'react';

import { OutlinedTextFieldProps } from '@mui/material';

import { FieldLabel } from '~/components/FieldLabel';

import { StyledInput } from './styled';

interface ITextFieldProps extends Omit<OutlinedTextFieldProps, 'variant'> {
  errorMessage?: string;
  onSubmit?(): void;
}

export const TextField: React.FC<ITextFieldProps> = (props) => {
  const {
    id: textId,
    label,
    InputLabelProps,
    errorMessage,
    helperText,
    onSubmit,
    ...other
  } = props;
  const internalId = useId();
  const id = textId ? textId : label ? internalId : undefined;

  return (
    <>
      {label && <FieldLabel htmlFor={id}  {...InputLabelProps}>{label}</FieldLabel>}
      <StyledInput
        id={id}
        {...other}
        helperText={errorMessage || helperText}
        error={(errorMessage || '').length > 0}
        variant="outlined"
      />
    </>
  );
};
